module.exports = __webpack_public_path__ + "static/media/rectangle-wide.e452bd7f.svg";